/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ContextCloak {
    Default = '0',
    User = 1,
    Location = 2,
}
